var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6a1 1 0 10-2 0v11.409a1 1 0 002 0V6zM6 11a1 1 0 10-2 0v6.409a1 1 0 002 0V11zM14.5 12a1 1 0 011 1v4.409a1 1 0 01-2 0V13a1 1 0 011-1zM20 10a1 1 0 10-2 0v7.409a1 1 0 002 0V10z",
    fill: "#fff"
  })));
}
export default SvgSoundOn;